@import '../../theme/global.scss';

:host {
  display: block;
  @include box-sizing;
  @include set-font;
}

.select-menu-btn {
  align-items: center;
  background-color: $base-light;
  border: 1px solid $gray-300;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  color: $gray-500;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  justify-content: space-between;
  line-height: 24px;
  padding: 0.5rem 0.75rem;
  text-align: left;
  width: 100%;

  @media (min-width: map-get($breakpoints, 'md')) {
    font-size: 14px;
    line-height: 20px;

  }

  &:focus-visible {
    border: 1px solid #2563EB;
    box-shadow: 0 0 0 1px #2563EB, 0 1px 2px rgba(0, 0, 0, 0.05);
    outline: none;
  }

  &--error {
    border: 1px solid #EF4444;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  &--disabled,
  &--locked{
    background-color: $gray-100;
    border: 1px solid $gray-300;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    cursor: auto;

    .chevron-icon {
      color: $gray-400;
    }
  }
}

.btn-selected-name {
  align-items: center;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-btn-right {
  display: flex;
}

.error-icon,
.lock-closed-icon{
  margin-left: 4px;
}

.chevron-icon {
  color: $gray-500;
}

.has-value,
.select-menu-btn--locked{
  color: $gray-800;
}

.select-menu-btn-wrapper {
  position: relative;
}

.help-text {
  color: $gray-500;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 4px;

  p {
    margin: 0;
  }
}

.label {
  color: $gray-800;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 4px;
}

.corner-hint-wrapper {
  align-items: center;
  display: flex;
  justify-content: space-between;

  &--right {
    justify-content: flex-end;
  }
}

.required {
  color: $red-500;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-left: 0.25rem;
}

.corner-hint {
  color: $gray-500;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.dropdown-list {
  background-color: $base-light;
  border: 1px solid $gray-200;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: none;
  list-style: none;
  margin: 8px 0 0;
  max-height: 280px;
  overflow: auto;
  padding: 8px 0;
  position: absolute;
  width: 100%;
  z-index: 10000;

  &.open {
    @media (min-width: map-get($breakpoints, 'md')) {
      display: block;
    }
  }

  &.relative {
    position: relative;
  }
}

.dropdown-item {
  align-items: center;
  color: $gray-800;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 8px;
  padding: 8px 16px;


  &:last-child {
    margin-bottom: 0;
  }

  &.active {
    background-color: $blue-100;
  }

  &:hover {
    background-color: $blue-200;

    &:not(.active) {
      snap-checkbox-button input {
        background-color: $base-light;
      }
    }
  }

  &-avatar {
    height: 1.5rem;
    margin-right: 0.5rem;
    object-fit: cover;
    width: 1.5rem;
  }
}

snap-checkbox-button {
  margin-right: 8px;
}

.snap-indicator-gray {
  --indicator-background-color: #475569;
  --indicator-text-color: #fff;
}

snap-indicator {
  margin-left: 4px;
}

.dropdown-list-modal {
  inset: 0;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  transition: all 0.3s ease 0s;

  &.open {
    opacity: 1;
    pointer-events: auto;
    z-index: 10001;

    @media (min-width: map-get($breakpoints, 'md')) {
      opacity: 0;
      pointer-events: none;
    }

    .dropdown-list-modal-container {
      bottom: 50%;
    }
  }

  &-backdrop {
    background-color: rgba(0, 0, 0, 0.25);
    contain: strict;
    display: block;
    inset: 0;
    position: absolute;
    touch-action: none;
    z-index: 2;
  }

  &-container {
    background-color: rgb(255, 255, 255);
    bottom: -100%;
    height: 100%;
    left: 50%;
    max-height: 100%;
    position: fixed;
    transform: translate(-50%, 50%);
    transition: all 0.3s ease 0s;
    width: 100%;
    z-index: 10;
  }

  &-header {
    align-items: center;
    border-bottom: 1px solid $gray-200;
    color: $gray-800;
    display: flex;
    font-size: 16px;
    font-weight: 600;
    justify-content: space-between;
    line-height: 24px;
    padding: 16px 16px 8px;
  }

}

.modal-list {
  height: calc(100vh + -125px);
  list-style: none;
  margin: 20px 0 0;
  overflow: auto;
  padding: 0;
}

.modal-list-item {
  align-items: center;
  color: $gray-800;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 8px;
  padding: 8px 16px;

  &.active {
    background-color: $blue-100;

    &:hover {
      background-color: $blue-200;

      &:not(.active) {
        snap-checkbox-button input {
          background-color: $base-light;
        }
      }

    }
  }
}

.snap-select-menu-search {
  margin: 8px 16px;
  position: relative;
}

.snap-select-menu-icon-search {
  align-items: center;
  color: $gray-400;
  display: flex;
  inset: 0 auto 0 0;
  padding-left: 0.75rem;
  padding-right: 0;
  pointer-events: none;
  position: absolute;
}

.snap-select-menu-icon-close {
  align-items: center;
  bottom: 0;
  color: $gray-400;
  cursor: pointer;
  display: flex;
  margin-right: 0.75rem;
  position: absolute;
  right: 0;
  top: 0;
}

.snap-select-search-field {
  border: 1px solid $gray-300;
  border-radius: 0.625rem;
  box-shadow: 0 1px 2px rgb(0, 0, 0, 0.05);
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.5rem 0.75rem 0.5rem 2.5rem;
  width: 100%;

  &:focus {
    border-color: $blue-600;
    box-shadow: 0 0 0 1px $blue-600, 0 1px 2px rgb(0, 0, 0, 0.05);
  }

  &:focus-visible {
    outline: none;
  }

  &.active {
    padding-left: 13px;
  }
}

.dropdown-list-modal-body {
  .snap-select-menu-search {
    margin-top: 16px;
  }
}

snap-action-sheet {
  .modal-list {
    border-top: 1px solid $gray-200;
    margin-top: 0;
  }

  .snap-select-menu-search {
    margin-top: 16px;
  }
}

.no-result-container {
  margin: 16px;
}

.no-result-title {
  color: $gray-800;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 8px;
}

.no-result-body {
  color: #64748B;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
}
